import React, { Children, Component } from "react"
import { Column } from "../../components/DataGrid/types/types"
import { alphanumericCompare } from "../../services/utils/sort-util"
import { MathKatex2 } from "../../components/MathKatex"
import DataGrid from "../../components/DataGrid"
import { NO_INFO_FOUND } from "../../constants"
import { ITeacherFlashcard } from "./types"

interface Props {
    flashcards: ITeacherFlashcard[]
    category: string
    onStartPresentation?: (flashcard: ITeacherFlashcard) => void
}

interface State {

}

export default class VocabFlashcards extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
    }

    getSubcategoriesNames = (flashcards: any[]) => {
        let allSubcategoryNames = flashcards.map(fc => fc.subcategory)
        let subcategoryNames = Array.from(new Set(allSubcategoryNames)).sort()

        return subcategoryNames
    }

    handleClick = (flashcard?: ITeacherFlashcard) => {
        let {onStartPresentation} = this.props

        if (onStartPresentation && flashcard) {
            onStartPresentation(flashcard)
        }
    }

    getWordsWithLinks = (flashcards: ITeacherFlashcard[], words: string[]) => {
        let list = words.map(word => {
            let flashcard = flashcards.find(fc => fc.cardFront === word)
            return (
                <>
                    <button className="btn btn--text-orange btn--bg-orange word-btn" onClick={e => this.handleClick(flashcard)}>{word}</button>
                </>
            )
        })

        return list
    }

    createCategoricalData = (flashcards: ITeacherFlashcard[]) => {
        if (!flashcards || flashcards.length === 0) return

        let allData: any[] = []
        let subcategoryNames = this.getSubcategoriesNames(flashcards)

        subcategoryNames.forEach((subcategoryName, idx) => {
            let flashcardssubcategories = flashcards.filter(fc => fc.subcategory === subcategoryName)
            let words = flashcardssubcategories.map(fc => fc.cardFront)
            let wordsWithLinks = this.getWordsWithLinks(flashcardssubcategories, words)
            let subcategoryMainFlashcard = flashcardssubcategories[0]
            let {subcategory, subcategoryDescription} = subcategoryMainFlashcard
            let processedData = {
                category: {
                    content: <MathKatex2 mixedContent={`<h2>${subcategory}</h2>`}/> ,
                    comparator: `${subcategory}-${idx}`,
                },
                description: {
                    content: subcategoryDescription,
                    comparator: subcategoryDescription,
                },
                words: {
                    content: wordsWithLinks,
                    comparator: words,
                }
            }

            allData.push({
                data: processedData, 
                id: `teacher-flashcards-vocab-${idx}` 
            })
        })

        return allData
    }

    render() {
        let {flashcards} = this.props
        let setIds = Array.from(new Set(flashcards.map(flashcard => flashcard.setId))).sort() as string[]

        return (
            <div className="teacher-flashcards-container flashcards-teacher-vocab">
                { setIds.map(setId => {
                    let flashcardsInSet = flashcards.filter(fc => fc.setId === setId)
                    let setName = flashcardsInSet[0].setName
                    let data = this.createCategoricalData(flashcardsInSet)

                    return (
                        <div className="teacher-flashcards-info">
                            <h1>{setName}</h1>

                            <div className="teacher-flashcards-">
                                <DataGrid
                                    columns={columns}
                                    className={"teacher-flashcards-table"}
                                    data={data}
                                    emptyText={NO_INFO_FOUND}
                                />
                            </div>
                        </div>
                    )})
                }
            </div>
        )
    }
}

//--- Helpers ---
const sortable = false
const sortMethod = alphanumericCompare
const columns: Column[] = [
    {
        title: "CATEGORY",
        dataProperty: "category",
        width: "220px",
        customTooltip: "Flashcard Category",
        sortable,
        sortMethod,
    },
    {
        title: "DESCRIPTION",
        dataProperty: "description",
        width: "30%",
        customTooltip: "Category Description",
        sortable,
        sortMethod,
    },
    {
        title: "INSTRUCTIONAL SLIDESHOW",
        width: "54%",
        dataProperty: "words",
        customTooltip: "Instructional Slideshow",
        sortable,
        sortMethod,
    },
]
